<template>
	<section>
		<compWrapper :title="$t('fbb.costmanage.base_info', { defaultValue: '基础信息' })" theme="primary">
			<compFormEdit
				v-if="type==='add'||(handleAuth('fbb.systemdelivercarrier.save')&&type=='edit')"
				class="margin-layout"
				ref="formbase"
				:formdata="getBase"
				v-model="formData"
			></compFormEdit>
			<compFormQuery v-else class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
			<vButtonGroup slot="footer">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup>
		</compWrapper>
		<!-- <compWrapper :title="$t('fbb.headlogistics.attach_info', { defaultValue: '附加信息' })" theme="primary" v-if="type!=='add'">
			<compFormEdit
				v-if="type!=='query'"
				class="margin-layout"
				:formdata="getAttach"
				v-model="attachData"
			></compFormEdit>
			<compFormQuery v-else class="margin-layout" :formdata="getAttach" :value="attachData"></compFormQuery>
		</compWrapper>
		<compWrapper :title="$t('fbb.warehouse.customer_list', { defaultValue: '客户列表' })" theme="info" v-if="type!=='add'">
			<compCustomer class="margin-layout" ref="orgIds" :data="orgIds"></compCustomer>
		</compWrapper>
		<compWrapper :title="$t('fbb.organization.warehouse_list', { defaultValue: '仓库列表' })" theme="info" v-if="type!=='add'">
			<compwarehouse class="margin-layout" ref="warehosueIds" :data="warehosueIds"></compwarehouse>
		</compWrapper> -->
		<compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpCarrierService, HttpSaveCarrierService } from '@/service/basicdata';
import mixin from "./mixin";
import compCustomer from "./customer";
import compwarehouse from "./warehouse";
export default {
	mixins: [mixin],
	components: {
		compCustomer,
		compwarehouse,
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			formData: {},
			attachData: {},
			opLogList: [],
			orgIds: [],
			warehosueIds: [],

		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('common', ['getCurrencyList']),
		...mapGetters('dictionary', ['getCarrierAllList']),
		isEdit() {
			return this.type === 'edit'
		},
		/**
		 * 根据状态显示不同按钮
		 */
		getStatusBtns() {
			const btn = [{
				name: this.$t('global.common.save', { defaultValue: "保存" }),
				theme: 'primary',
				show: this.type !== 'query',
				run: this.save
			}, {
				name: this.$t('global.common.return', { defaultValue: "返回" }),
				theme: 'default',
				show: true,
				run: this.cancel
			}]
			return btn.filter(item => item.show);
		},

		getBase() {
			return [{
				label: this.$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' }),
				key: "carrierCode",
				tag: 'vSelect',
				// query: this.isEdit,
				options: this.getCarrierAllList,
				props: {
					filterable: true,
				}
			}, {
				label: this.$t('fbb.basicdata.carrier_service_type', { defaultValue: '配送类型' }),
				key: "type",
				tag: 'vSelect',
				options: this.getDeliveryTypes.slice(1),
				// query: this.isEdit,
			},
			{
				label: this.$t('fbb.carrieraccount.carrieraccount_service', { defaultValue: '承运商服务' }),
				key: "carrierServiceCode",
				// query: this.isEdit,
			},
			{
				label: this.$t('fbb.basicdata.carrier_active', { defaultValue: '启用状态' }),
				key: "active",
				tag: 'vSelect',
				options: this.getActive.slice(1),
				// query: this.isEdit,
			},
			{
				label: this.$t('fbb.basicdata.carrier_service', { defaultValue: '承运商服务名称' }),
				key: "carrierServiceName",
				// query: this.isEdit,
			},
			{
				label: this.$t('erp.product_channel.currency', { defaultValue: '币种' }),
				key: "currency",
				tag: 'vSelect',
				options: this.getCurrencyList,
				// query: this.isEdit,
			},
			{
				label: this.$t('fbb.basicdata.carrier_interface_code', { defaultValue: '接口编码' }),
				key: "interfaceEncoding",
				required: false,
			},
			{
				label: this.$t('global.common.notes', { defaultValue: '备注' }),
				key: "memo",
				tag: 'vTextarea',
				required: false,
			},
			];
		},
		getAttach() {
			return [
				{
					label: this.$t('fbb.basicdata.carrier_volume', { defaultValue: '体积重系数' }),
					key: "volumeWeight",
					tag: "vInputNumber",
					span: 6,
					required: false,
					props: {
						min: 0,
					},
				},
				{
					label: this.$t('erp.product.signature', { defaultValue: '签收服务' }),
					key: "isSignature",
					tag: "vRadio",
					span: 24,
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' })
					}, {
						trueValue: 0,
						label: this.$t('global.common.close', { defaultValue: '关闭' })
					}]
				},
				{
					label:  this.$t('fbb.basicdata.carrier_insure', { defaultValue: '保价服务' }),
					key: "isInsure",
					tag: "vRadio",
					span: 24,
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' })
					}, {
						trueValue: 0,
						label: this.$t('global.common.close', { defaultValue: '关闭' })
					}]
				},
			]
		},
		// 操作历史
		getLogcolumns() {
			return [{
				title: this.$t('global.common.operator', { defaultValue: '操作人' }),
				key: 'opUserName',
			},
			{
				title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
				key: 'opAction',
				// render:(h,{row})=>{
				//     return <div>{row.carrierServiceCode} ({row.carrierCode} {row.carrierServiceName})</div>
				// }
			},

			{
				title: this.$t('fbb.accountmanage.param', { defaultValue: '更改字段' }),
				key: 'changeField',
			},
			{
				title: this.$t('global.common.before_value', { defaultValue: '更改前值' }),
				key: 'beforeChange',
			},
			{
				title: this.$t('global.common.after_value', { defaultValue: '更改后值' }),
				key: 'afterChange',
			},
			{
				title: this.$t('global.common.operate_time', { defaultValue: '操作时间' }),
				key: 'opAt',
			},]
		}
	},
	methods: {
		//获取计划单详情
		getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
			HttpCarrierService({ id: this.id }).then(res => {
				this.loading = false;
				const data = res.data || {};
				this.formData = data.systemDeliveryCarrierBaseInfo;
				this.attachData = {
					id: this.id,
					isInsure: data.isInsure || 0,
					isSignature: data.isSignature || 0,
					volumeWeight: data.volumeWeight || 0,
				}
				this.orgIds = data.orgIds;
				this.warehosueIds = data.warehosueIds;
				this.opLogList = data.carrierRuleLogs;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},

		//更新单据数据
		async save() {
			if (this.type === 'add') {
				const valid = await this.$refs.formbase.validate();
				if (!valid) return;
			}
			this.loading = true;
			HttpSaveCarrierService({
				...this.attachData,
				systemDeliveryCarrierBaseInfo: this.formData,
				// warehosueIds: this.$refs.warehosueIds ? this.$refs.warehosueIds.targetKeys : [],
				orgIds: this.$refs.orgIds ? this.$refs.orgIds.targetKeys : [],
			}).then(this.cancel).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		cancel() {
			this.$router.push({
				name: 'basicdataCarrierservice'
			})
		}
	}
};
</script>
